module.exports = __webpack_public_path__ + "static/media/sow-login-banner1.1e25ad6e.png";